import { useQuery } from "@tanstack/react-query";
import { USER_BLOG_DOMAINS } from "../../constants/QueryKeys";
import UserService from "../../service/UserService";
import { queryClient, STATIC_QUERY_DEFAULTS } from "../../utils/QueryUtils";
import { getUserId } from "./useAccount";

/** @typedef {import("@/types/data/Domain.mjs").UserBlog} UserBlog */
/** @typedef {{ blogs: UserBlog[] }} UserBlogsData */
/**
 * @template T
 * @typedef {import("@/types/TypeUtils.mjs").QueryResultRest<T>} QueryResultRest
 */
/**
 * @template T
 * @typedef {import("@/types/TypeUtils.mjs").QueryHookOptions<T>} QueryHookOptions
 */

const defaults = STATIC_QUERY_DEFAULTS;

/**
 * The user's WordPress blogs.
 * @param {QueryHookOptions<UserBlogsData>} [options] - Extra `useQuery` options, spread over the defaults.
 * @returns {{ blogDomains: UserBlog[] | undefined } & QueryResultRest<UserBlogsData>}
 */
const useUserBlogDomains = (options = {}) => {
  const { data, ...rest } = useQuery({
    queryKey: [USER_BLOG_DOMAINS],
    queryFn: () => /** @type {Promise<UserBlogsData>} */ (UserService.getBlogDomains(getUserId())),
    ...defaults,
    ...options,
  });
  return { blogDomains: data?.blogs, ...rest };
};

export const invalidateUserBlogDomains = () => {
  queryClient.invalidateQueries({ queryKey: [USER_BLOG_DOMAINS] });
};

export default useUserBlogDomains;
